<template>
  <div class="container-box no-scroll">
    <LoadingOverlay
      :enabled="
        isLoadingEdition ||
          isLoadingCreation ||
          isFetchingNews ||
          isFetchingFields
      "
    />
    <CompareVersionsModal
      v-if="isOpenDialogCompareVersion && !isCreationMode"
      :draft="getDraftSlugs"
      :current="selectedStory.data"
      @close="handleOpenDialogCompareVersion"
      @save="updateStory"
    />
    <div class="story-box">
      <div
        class="story-middle"
        :class="{ 'editor-actions': this.storyMode !== storyModes.VIEW }"
        v-if="!conflictDetail"
      >
        <!-- view story mode : form disabled -->
        <template>
          <div class="story-top">
            <div class="story-title">
              <v-text-field
                :value="[selectedStory ? title : '']"
                class="retranca"
                solo
                single-line
                hide-details
                flat
                :readonly="isViewMode"
                :placeholder="isViewMode ? '' : 'Digite aqui sua retranca...'"
                @input="handleTitle"
              >
              </v-text-field>
            </div>

            <v-tooltip bottom v-if="showProgressDraft">
              <template v-slot:activator="{ on }">
                <v-progress-circular
                  v-on="on"
                  indeterminate
                  color="primary"
                  width="2"
                  size="15"
                />
              </template>
              <span>Salvando rascunho</span>
            </v-tooltip>
            <div v-if="shouldShowEdit()" class="story-actions">
              <editor-menu-bar
                :class="{ disabled: isViewMode }"
                :editor="editor"
                v-slot="{ commands, isActive }"
              >
                <div class="menubar">
                  <v-btn
                    :dark="$vuetify.breakpoint.xsOnly"
                    large
                    icon
                    :class="{ 'is-active': isActive.bold() }"
                    @click="commands.bold"
                  >
                    <v-icon>format_bold</v-icon>
                  </v-btn>
                  <v-btn
                    :dark="$vuetify.breakpoint.xsOnly"
                    large
                    icon
                    :class="{ 'is-active': isActive.italic() }"
                    @click="commands.italic"
                  >
                    <v-icon>format_italic</v-icon>
                  </v-btn>
                  <v-btn
                    :dark="$vuetify.breakpoint.xsOnly"
                    icon
                    large
                    :class="{ 'is-active': isActive.underline() }"
                    @click="commands.underline"
                  >
                    <v-icon>format_underline</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    large
                    depressed
                    title="adicionar template de contato"
                    :dark="$vuetify.breakpoint.xsOnly"
                    @click="addContactTemplate"
                  >
                    <v-icon>person_add_alt_1</v-icon>
                  </v-btn>
                </div>
              </editor-menu-bar>

              <div class="divisor right"></div>

              <!-- // -->
              <!-- Metadata : Desktop -->
              <v-btn
                large
                color="secondary"
                :disabled="metadataButtonDisabled()"
                v-show="$vuetify.breakpoint.lgAndUp"
                @click.stop="showExtraFields = !showExtraFields"
              >
                Exibir Metadados
              </v-btn>
              <!-- Metadata : Mobile -->
              <v-btn
                large
                color="secondary"
                class="square"
                :disabled="metadataButtonDisabled()"
                v-show="!$vuetify.breakpoint.lgAndUp"
                @click.stop="showExtraFields = !showExtraFields"
              >
                <v-icon>mdi-tag-outline</v-icon>
              </v-btn>

              <!-- // -->
              <!-- Cancel : Desktop -->
              <v-btn
                :dark="$vuetify.breakpoint.xsOnly"
                large
                color="secondary"
                v-show="!isViewMode && $vuetify.breakpoint.lgAndUp"
                @click="genericCancel"
              >
                Cancelar
              </v-btn>
              <!-- Cancel : Mobile -->
              <v-btn
                large
                color="secondary"
                class="square"
                v-show="!isViewMode && !$vuetify.breakpoint.lgAndUp"
                @click="genericCancel"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-btn
                v-if="canCreateOrEditStory && hasSlugId"
                @click="handleEditClick(false)"
                :class="{ 'is-active': storyMode === storyModes.EDITION }"
                large
                color="primary"
                class="white--text"
                :disabled="!shouldShowStoryBody"
                v-show="isViewMode && $vuetify.breakpoint.lgAndUp"
              >
                Editar Pauta
              </v-btn>
              <!-- Metadata : Mobile -->
              <v-btn
                v-if="canCreateOrEditStory && hasSlugId"
                @click="handleEditClick(false)"
                large
                color="primary"
                class="square white--text"
                :class="{ 'is-active': storyMode === storyModes.EDITION }"
                :disabled="!isCurrent() || !shouldShowStoryBody"
                v-show="isViewMode && !$vuetify.breakpoint.lgAndUp"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <!-- // -->
              <!-- Save : Desktop -->
              <v-btn
                v-if="canCreateOrEditStory"
                :dark="$vuetify.breakpoint.xsOnly"
                large
                color="primary"
                class="white--text"
                v-show="!isViewMode && $vuetify.breakpoint.lgAndUp"
                @click="genericSave"
              >
                Salvar
              </v-btn>
              <!-- Save : Mobile -->
              <v-btn
                v-if="canCreateOrEditStory"
                large
                color="primary"
                class="square"
                v-show="!isViewMode && !$vuetify.breakpoint.lgAndUp"
                @click="genericSave"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </div>
          </div>
        </template>

        <v-expand-transition>
          <div class="story-fields" v-show="showExtraFields">
            <div class="column">
              <template v-if="isCreationMode || isEditMode">
                <div v-for="(field, index) in fieldMapping" :key="index">
                  <template v-if="field.type === 'comboboxcell'">
                    <v-select
                      v-if="!field.isEditable"
                      :label="field.label"
                      clearable
                      @change="handleClearField(field)"
                      outlined
                      color="graydark"
                      hide-details
                      :disabled="field.isReadOnly"
                      autocomplete="new-password"
                      v-model="extraFields[field.field]"
                      :items="getFieldComboboxOptions(field)"
                      prepend-inner-icon="mdi-label-outline"
                    ></v-select>
                    <v-combobox
                      v-else
                      :label="field.label"
                      clearable
                      @change="handleClearField(field)"
                      outlined
                      color="graydark"
                      hide-details
                      :disabled="field.isReadOnly"
                      autocomplete="new-password"
                      v-model="extraFields[field.field]"
                      :items="getFieldComboboxOptions(field)"
                      prepend-inner-icon="mdi-label-outline"
                    ></v-combobox>
                  </template>
                  <template v-else-if="field.type === 'checkboxcell'">
                    <v-checkbox
                      v-model="extraFields[field.field]"
                      color="graydark"
                      hide-details
                      :disabled="field.isReadOnly"
                      :label="field.label"
                    />
                  </template>
                  <template v-else-if="field.type === 'datecell'">
                    <v-menu
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="extraFields[field.field]"
                          v-on="on"
                          v-bind="attrs"
                          color="graydark"
                          outlined
                          clearable
                          :label="field.label"
                          @change="handleClearField(field)"
                          hide-details
                          prepend-inner-icon="event"
                          append-icon="mdi-menu-down"
                          readonly
                        ></v-text-field>
                      </template>
                      <MyDatetimePicker
                        :datetime="extraFields[field.field]"
                        @change="i => (extraFields[field.field] = i)"
                      />
                    </v-menu>
                  </template>
                  <template v-else-if="field.type === 'durationcell'">
                    <v-menu
                      transition="scale-transition"
                      ref="refmenu"
                      offset-y
                      :close-on-content-click="false"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="extraFields[field.field]"
                          v-on="on"
                          v-bind="attrs"
                          color="graydark"
                          outlined
                          clearable
                          :label="field.label"
                          @change="handleClearField(field)"
                          hide-details
                          prepend-inner-icon="schedule"
                          append-icon="mdi-menu-down"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-model="extraFields[field.field]"
                        format="24hr"
                        scrollable
                        use-seconds
                        color="primary"
                        locale="pt-br"
                      ></v-time-picker>
                    </v-menu>
                  </template>
                  <template v-else>
                    <v-text-field
                      v-model="extraFields[field.field]"
                      :label="field.label"
                      color="graydark"
                      outlined
                      hide-details
                      autocomplete="new-password"
                      :disabled="field.isReadOnly"
                      prepend-inner-icon="mdi-label-outline"
                    ></v-text-field>
                  </template>
                </div>
              </template>

              <template v-else-if="isViewMode">
                <div
                  class="meta-chips"
                  v-for="(tag, index) in selectedStory.data.extra_fields"
                  :key="index"
                >
                  <v-chip class="meta-chip" label v-if="tag.label">
                    {{ extraFieldContent(tag) }}
                  </v-chip>
                </div>
              </template>
            </div>
          </div>
        </v-expand-transition>

        <editor-content
          class="story-content editor__content"
          :editor="editor"
          v-if="shouldShowStoryBody"
        />
        <div
          v-else
          class="protected-body"
          title="Essa retranca foi protegida pelo autor e somente pode ser visualizada no iNews com a senha."
        >
          <v-icon size="300px" color="rgba(0,0,0, 0.24)">lock</v-icon>
        </div>
        <!-- creation or edition form -->

        <!-- form input/content -->
      </div>

      <v-app-bar
        app
        bottom
        hide-on-scroll
        flat
        height="64px"
        class="story-footer mobile"
      >
        <div class="slot left">
          <div class="slot-item path">
            <v-icon left>folder_special</v-icon>
            <v-chip
              class="path"
              v-for="(tag, index) in tags"
              :key="index"
              outlined
              >{{ tag }}
            </v-chip>
          </div>

          <div class="slot-item" v-if="!isCreationMode">
            <v-chip outlined>
              <v-icon>date_range</v-icon>
              {{ storyCreationDate }}
            </v-chip>
          </div>

          <div class="slot-item" v-if="!isCreationMode">
            <v-chip outlined>
              <v-icon>access_time</v-icon>
              {{ storyCreationTime }}
            </v-chip>
          </div>

          <div class="slot-item" v-if="!isCreationMode">
            <v-chip outlined class="name">
              <v-icon>person</v-icon>
              {{ displayedAuthor }}
            </v-chip>
          </div>
        </div>

        <div class="slot right">
          <div class="slot-item"></div>
        </div>
      </v-app-bar>

      <div class="story-footer">
        <div class="slot left">
          <div class="slot-item path">
            <v-icon left>folder_special</v-icon>
            <v-chip
              class="path"
              v-for="(tag, index) in tags"
              :key="index"
              outlined
              >{{ tag }}
            </v-chip>
          </div>

          <div class="slot-item" v-if="!isCreationMode">
            <v-chip outlined>
              <v-icon>date_range</v-icon>
              {{ storyCreationDate }}
            </v-chip>
          </div>

          <div class="slot-item" v-if="!isCreationMode">
            <v-chip outlined>
              <v-icon>access_time</v-icon>
              {{ storyCreationTime }}
            </v-chip>
          </div>

          <div class="slot-item" v-if="!isCreationMode">
            <v-chip outlined class="name">
              <v-icon>person</v-icon>
              {{ displayedAuthor }}
            </v-chip>
          </div>
        </div>

        <div class="slot right">
          <div class="slot-item"></div>
        </div>
      </div>
    </div>
    <!-- error snackbar -->
    <v-snackbar
      v-model="errorSnack"
      :timeout="snackbarTimeout"
      :multi-line="true"
      class="error-snack-custom"
      color="error"
      bottom
      right
    >
      <span v-for="(message, index) in errorMessages" :key="index">
        {{ message }}
      </span>
      <v-btn text @click="errorSnack = false">Entendi</v-btn>
    </v-snackbar>
    <!-- end error snackbar -->

    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="snackbarTimeout"
      bottom
      left
    >
      {{ this.feedbackMessage }}
      <v-btn color="primary" text @click="hideSnackbar()">Entendi</v-btn>
    </v-snackbar>
    <!-- Draft Confirm Dialog -->
    <SimpleConfirmDialog
      v-if="showDraftConfirmDialog"
      :title="draftDialogData.title"
      :text-btn-cancel="draftDialogData.textBtnCancel"
      :text-btn-confirm="draftDialogData.textBtnConfirm"
      :description="draftDialogData.description"
      @cancel="discardDraft"
      @confirm="handleEditClick(true)"
    />
  </div>
</template>
<script>
import { timeFormat, dateFormat } from '@/utils/date.js';
import { copyToClipboard } from '@/utils/text.js';
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import { Bold, Italic, Underline } from 'tiptap-extensions';
import { categories, actions } from '@/constants/analytics.js';
import { mapState } from 'vuex';
import { toLocalTime, formatSeconds } from '@/utils/date.js';
import { storyModes } from '@/utils/mappers.js';
import HltTag from '@/utils/hltMark.js';
import { contactTemplate } from '@/utils/contactTemplate';
import { countWords, escapeHTML } from '@/utils/text';
import _ from 'lodash';
import { getEnvVar } from '@/utils/getEnvVar';
import { isoDatetimeFormat } from '@/utils/date.js';
import MyDatetimePicker from '../shared/MyDatetimePicker.vue';
import LoadingOverlay from '../shared/LoadingOverlay.vue';
import SimpleConfirmDialog from '../shared/SimpleConfirmDialog.vue';
import storejs from 'store';
import CompareVersionsModal from './modal/compareVersionsModal/index.vue';

export default {
  components: {
    SimpleConfirmDialog,
    EditorContent,
    EditorMenuBar,
    MyDatetimePicker,
    LoadingOverlay,
    CompareVersionsModal,
  },
  data() {
    return {
      title: null,
      showProgressDraft: false,
      showDraftConfirmDialog: false,
      editor: null,
      snackbarTimeout: 6000,
      deleteDialog: false,
      storyModes,
      place: null,
      folder: null,
      index: null,
      errorMessages: [],
      errorSnack: false,
      showExtraFields: false,
      extraFields: {},
      labelExtraFields: 'Veja Mais',
      alreadyDisplayedContactMessage: false,
      lastSearchedWordCount: null,
      isOpenDialogCompareVersion: false,
      draft: null,
    };
  },
  props: ['storyMode', 'conflictDetail', 'selectedStory'],
  watch: {
    extraFields: {
      deep: true,
      handler() {
        this.syncDraft();
      },
    },
    storyMode: function(mode) {
      if (mode === storyModes.CREATION) {
        this.clearEditorInputs();
        this.makeEditorEditable();
        this.populateEmptyExtraFields();
      } else if (mode !== storyModes.EDITION) {
        this.disableEditor();
      }
    },
    currentBody() {
      if (
        this.aboveMinimumWordCount() &&
        this.wordCountSufficientlyDifferent()
      ) {
        this.searchRelatedVideos();
      }
    },
    fieldMapping() {
      this.populateEmptyExtraFields();
    },
  },
  mounted() {
    this.title = this.storyTitle;
    this.editor = new Editor({
      extensions: [new Bold(), new Italic(), new Underline(), new HltTag()],
      content: this.isCreationMode ? '' : this.storyBody,
      editable: this.isCreationMode ? true : false,
    });
    this.editor.on('update', () => {
      this.syncDraft();
    });
    if (this.isCreationMode) {
      this.setSaveFolder(this.$route.params.place, this.$route.params.folder);
      this.index = this.$route.query.index;
    } else {
      this.setSaveFolder(
        this.selectedStory.data.place,
        this.selectedStory.data.path,
      );
    }
    this.lastSearchedWordCount = countWords(escapeHTML(this.editor.getHTML()));
    if (this.canCreateOrEditStory && this.hasSlugId && this.shouldShowStoryBody)
      this.findDraft();
  },
  computed: {
    ...mapState({
      news: state => state.news.news,
      feedbackMessage: state => state.news.feedbackMessage,
      snackbarBox: state => state.news.snackbarBox,
      storyConflicts: state => state.news.storyConflicts,
      isWaitingConflicts: state => state.news.isWaitingConflicts,
      isFetchingNews: state => state.news.isFetchingNews,
      isFetchingFields: state => state.news.isFetchingFields,
      isLoadingEdition: state => state.news.isLoadingEdition,
      isLoadingCreation: state => state.news.isLoadingCreation,
      hasFolderWritePermission: state => state.news.writePermission,
      fieldMapping: state => state.news.fieldMapping,
      isManualSearch: state => state.videos.isManualSearch,
      currentUser: state => state.user.currentUser,
    }),

    isEditMode() {
      return this.storyMode === storyModes.EDITION;
    },
    draftDialogData() {
      return {
        title: 'Continuar edição',
        textBtnCancel: 'Descartar rascunho',
        textBtnConfirm: 'Continuar editando',
        description:
          'Essa retranca contém mudanças não salvas. Você pode continuar editando o rascunho para não perder o conteúdo.',
      };
    },

    draftStorageKey() {
      const story = this.selectedStory.data;
      const slug_id = this.$route.query.slug_id;
      return `draft_${this.currentUser.username}_${story.place}_${story.path}_${slug_id}`;
    },

    isCreationMode() {
      return this.storyMode === storyModes.CREATION;
    },

    isViewMode() {
      return this.storyMode === storyModes.VIEW;
    },

    hasSlugId() {
      return this.$route.query.slug_id;
    },

    canCreateOrEditStory() {
      if (!this.$route.query.slug_id && this.isEditMode) return false;
      if (this.isViewMode || this.isEditMode) {
        return this.selectedStory.parent_write_allowed || false;
      } else {
        return this.hasFolderWritePermission;
      }
    },

    operationLabel() {
      return storyModes.EDITION === this.storyMode ? 'Edição' : 'Criação';
    },
    snackbar: {
      get() {
        return this.snackbarBox;
      },
      set(value) {
        this.$store.dispatch('news/snackbarTrigger', value);
      },
    },
    storyCreationDate() {
      if (!this.selectedStory) return null;

      return dateFormat(
        toLocalTime(this.selectedStory.data.processing_date) ||
          toLocalTime(this.selectedStory.data.modified_date) ||
          toLocalTime(this.selectedStory.data.creation_date) ||
          toLocalTime(this.selectedStory.data.ingest_date),
      );
    },
    storyCreationTime() {
      if (!this.selectedStory) return null;

      return timeFormat(
        toLocalTime(this.selectedStory.data.processing_date) ||
          toLocalTime(this.selectedStory.data.modified_date) ||
          toLocalTime(this.selectedStory.data.creation_date) ||
          toLocalTime(this.selectedStory.data.ingest_date),
      );
    },
    displayedAuthor() {
      if (!this.selectedStory) return null;

      return (
        this.selectedStory.data.modified_by || this.selectedStory.data.author
      );
    },
    tags() {
      if (this.isCreationMode) {
        if (!this.folder) return [];
        return this.folder.split('.');
      } else {
        return this.selectedStory
          ? this.selectedStory.data.path.split('.')
          : [];
      }
    },
    storyBody() {
      return this.selectedStory ? this.selectedStory.data.body : null;
    },
    storyTitle() {
      return this.selectedStory ? this.selectedStory.data.title : null;
    },
    getDraftSlugs() {
      return {
        ...this.formattedStory,
        extra_fields: this.draftExtraFields,
      };
    },
    draftExtraFields() {
      return this.fieldMapping.map(item => ({
        ...item,
        value: this.extraFields[item.field],
      }));
    },
    formattedStory() {
      if (!this.selectedStory) return null;

      if (storyModes.CREATION === this.storyMode) {
        return this.getNewStory();
      } else {
        const story = {
          title: this.title,
          body: this.editor.getHTML(),
          extra_fields: this.extraFields,
          story_id: this.selectedStory.story_id,
          slug_id: this.$route.query.slug_id,
        };
        for (const [key, value] of Object.entries(this.selectedStory.data)) {
          if (!(key in story)) {
            story[key] = value;
          }
        }
        return story;
      }
    },
    currentBody() {
      return this.editor ? this.editor.getHTML() : '';
    },
    currentWordCount() {
      return countWords(escapeHTML(this.currentBody));
    },
    shouldShowStoryBody() {
      if (!('is_protected' in this.selectedStory.data)) return true;
      return (
        !this.selectedStory.data.is_protected ||
        (this.selectedStory.data.is_protected &&
          (this.selectedStory.data.modified_by === this.currentUser.username ||
            this.selectedStory.data.author === this.currentUser.username))
      );
    },
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    formatSeconds,
    formatExtraFields() {
      return this.fieldMapping.map(field => ({
        value: this.extraFields[field.field],
        label: field.label,
        type: field.type,
      }));
    },
    handleOpenDialogCompareVersion() {
      this.isOpenDialogCompareVersion = !this.isOpenDialogCompareVersion;
    },
    handleTitle(value) {
      this.title = value;
      this.syncDraft();
    },
    syncDraft: _.debounce(function() {
      if (this.isEditMode && !this.showDraftConfirmDialog && this.hasSlugId) {
        this.showProgressDraft = true;
        this.upsertDraft();
        setTimeout(() => {
          this.showProgressDraft = false;
        }, 2400);
      }
    }, parseInt(process.env.VUE_APP_DEBOUNCE_SYNC_DRAFT)),

    findDraft() {
      const draft = storejs.get(this.draftStorageKey);
      this.draft = draft;
      if (draft) this.showDraftConfirmDialog = true;
    },
    useDraft() {
      const draft = storejs.get(this.draftStorageKey);
      this.editor.setContent(draft.body);
      this.title = draft.title;
      this.extraFields = draft.extraFields;
      this.showDraftConfirmDialog = false;
      this.launchAnalytics({
        category: categories.edit,
        action: actions.useEditDraft,
        label: draft.title,
      });
    },
    upsertDraft() {
      storejs.set(this.draftStorageKey, {
        title: this.title,
        body: this.editor.getHTML(),
        extraFields: this.extraFields,
      });
    },
    discardDraft() {
      this.launchAnalytics({
        category: categories.edit,
        action: actions.discardEditDraft,
        label: this.storyTitle,
      });
      this.deleteDraft();
    },
    deleteDraft() {
      storejs.remove(this.draftStorageKey);
      this.showDraftConfirmDialog = false;
    },
    setSaveFolder(place, folder) {
      this.place = place;
      this.folder = folder;
    },
    getNewStory() {
      return {
        title: this.title,
        path: this.folder,
        place: this.place,
        body: this.editor.getHTML(),
        story_id: 0,
        extra_fields: this.extraFields,
        order: this.index,
      };
    },

    makeEditorEditable() {
      this.editor.setOptions({
        editable: true,
      });
    },
    disableEditor() {
      this.editor.setOptions({
        editable: false,
      });
    },
    setEditorInputs() {
      this.editor.setContent(this.storyBody);
      this.title = this.storyTitle;
    },
    clearEditorInputs() {
      this.editor.setContent('<p></p>');
      this.title = '';
      this.place = '';
      this.folder = '';
    },
    isEmptyBody() {
      return this.editor.getHTML() === '<p></p>';
    },
    isValidToUpdateStory() {
      this.errorMessages = [];

      if (!this.title) {
        this.errorMessages.push('A retranca não foi preenchida.');
      }
      if (this.isEmptyBody()) {
        this.errorMessages.push('O corpo da retranca não foi preenchido.');
        //focus on editor if title is already filled
        if (this.errorMessages.length === 1) this.editor.focus();
      }
      if (this.errorMessages.length > 0) {
        return false;
      }
      return true;
    },
    isValidToSaveStory() {
      this.errorMessages = [];

      if (!this.title) {
        this.errorMessages.push('A retranca não foi preenchida.');
      }
      if (this.isEmptyBody()) {
        this.errorMessages.push('O corpo da retranca não foi preenchido.');
        //focus on editor if title is already filled
        if (this.errorMessages.length === 1) this.editor.focus();
      }
      if (!this.place || !this.folder) {
        this.errorMessages.push('A gaveta precisa ser selecionada.');
      }
      if (this.errorMessages.length > 0) {
        return false;
      }
      return true;
    },
    shouldShowEdit() {
      return !!parseInt(process.env.VUE_APP_EDIT_ENABLED);
    },
    copy() {
      try {
        copyToClipboard(this.selectedStory.data.body);
        this.$emit('showMessage', 'Texto copiado para área de transferência');
      } catch (error) {
        this.$emit('copyError');
      }
    },
    close() {
      this.$emit('close');
    },
    launchAnalytics({ category, action, label }) {
      this.$store.dispatch('analyticsEvent', { category, action, label });
    },
    genericCancel() {
      if (this.isCreationMode) {
        this.cancelCreation();
      } else {
        this.cancelEdition();
      }
    },
    cancelCreation() {
      this.launchAnalytics({
        category: categories.create,
        action: actions.cancelClicked,
        label: '',
      });
      this.$router.go(-1);
    },
    cancelEdition() {
      this.setEditorInputs();
      this.deleteDraft();
      this.launchAnalytics({
        category: categories.edit,
        action: actions.cancelClicked,
        label: this.selectedStory.data.title,
      });
      this.$store.dispatch('news/cancelEdition');
    },
    genericSave() {
      if (this.isCreationMode) {
        this.saveStory();
      } else {
        this.handleOpenDialogCompareVersion();
      }
    },
    saveStory() {
      this.launchAnalytics({
        category: categories.create,
        action: actions.saveClicked,
        label: this.storyTitle,
      });

      if (this.isValidToSaveStory()) {
        this.$store.dispatch('news/createStory', this.getNewStory());
      } else {
        this.errorSnack = true;
      }
    },
    updateStory() {
      this.launchAnalytics({
        category: categories.edit,
        action: actions.saveClicked,
        label: this.storyTitle,
      });

      if (this.isValidToUpdateStory()) {
        this.$store.dispatch('news/updateStory', {
          story: this.formattedStory,
          contact: false,
        });
      } else {
        this.errorSnack = true;
      }
    },
    hideSnackbar() {
      this.$emit('hideSnackbar');
      this.snackbarTimeout = 6000;
    },
    async handleEditClick(shouldUseDraft = false) {
      this.launchAnalytics({
        category: categories.edit,
        action: actions.editClicked,
        label: this.storyTitle,
      });
      const success = await this.$store.dispatch(
        'news/getSlugToEdit',
        this.formattedStory,
      );
      if (success) {
        this.makeEditorEditable();
        this.setEditorInputs();
        this.populateExtraFields();
        if (shouldUseDraft) this.useDraft();
      }
    },

    metadataButtonDisabled() {
      if (!this.shouldShowStoryBody) return true;
      return (
        this.fieldMapping.length === 0 &&
        Object.keys(this.selectedStory.data.extra_fields).length === 0
      );
    },
    findExtraFieldInfo(field) {
      return this.fieldMapping.find(item => item.field == field);
    },
    extraFieldContent(tag) {
      let value = '';
      let fieldInfo = this.findExtraFieldInfo(tag.field);
      if (fieldInfo && fieldInfo.type === 'checkboxcell') {
        value = tag.value === 'true' ? '☑' : '☐';
      } else {
        value = tag.value ? tag.value : '---';
      }
      return `${tag.label} : ${value}`;
    },
    populateExtraFields() {
      let fieldObject = {};
      if (this.selectedStory && this.selectedStory.data.extra_fields) {
        this.selectedStory.data.extra_fields.forEach(function(item) {
          const fieldInfo = this.findExtraFieldInfo(item.field);
          if (fieldInfo && fieldInfo.type === 'datecell') {
            fieldObject[item.field] = isoDatetimeFormat(
              item.value,
              'DD/MM/YYYY - HH:mm:ss',
            );
          } else if (fieldInfo && fieldInfo.type === 'checkboxcell') {
            fieldObject[item.field] = item.value === 'true';
          } else {
            fieldObject[item.field] = item.value;
          }
        }, this);
        this.extraFields = fieldObject;
      }
    },
    populateEmptyExtraFields() {
      let fieldObject = {};
      if (this.fieldMapping) {
        this.fieldMapping.forEach(function(item) {
          if (!fieldObject[item.field]) {
            fieldObject[item.field] = '';
          }
        });
        this.extraFields = fieldObject;
      }
    },
    isCurrent() {
      return this.selectedStory.data.is_current;
    },
    tooltipLabel(value) {
      if (!this.isCurrent()) {
        return 'Esta retranca já foi arquivada e não pode mais ser editada ou deletada.';
      }
      return value;
    },
    addContactTemplate() {
      this.$store.dispatch('analyticsEvent', {
        category: categories.contacts,
        action: actions.contactTemplateButtonClicked,
        label: `id - ${this.selectedStory.story_id} / title - ${this.selectedStory.data.title}`,
      });
      this.editor.setContent(this.editor.getHTML() + contactTemplate);
      if (!this.alreadyDisplayedContactMessage) {
        this.snackbarTimeout = 0;
        this.$emit(
          'showMessage',
          'Você adicionou um template de contato. Além dos campos já fornecidos, qualquer outro campo pode ser' +
            ' adicionado no formato Campo: informação.',
        );
      }
      this.alreadyDisplayedContactMessage = true;
    },
    getFieldComboboxOptions(fieldOjbect) {
      const field = this.fieldMapping.find(
        el => el.label === fieldOjbect.label,
      );
      return field.options || [];
    },
    findFinalFieldList(optionsList) {
      let tempFieldList = [];
      optionsList.forEach(el => {
        if (el.value !== undefined) {
          tempFieldList.push(el.value);
        } else {
          tempFieldList = [
            ...tempFieldList,
            ...this.findFinalFieldList(el.values),
          ];
        }
      });
      return tempFieldList;
    },
    handleClearField(field) {
      if (this.extraFields[field.field] === null) {
        this.extraFields[field.field] = '';
      }
    },
    aboveMinimumWordCount() {
      const min_words = getEnvVar('VUE_APP_VIDEO_SEARCH_MIN_WORDS');
      return this.currentWordCount > parseInt(min_words);
    },
    wordCountSufficientlyDifferent() {
      const interval_words = getEnvVar('VUE_APP_VIDEO_SEARCH_INTERVAL_WORDS');
      return (
        Math.abs(
          (this.lastSearchedWordCount - this.currentWordCount) /
            parseInt(interval_words),
        ) > 1
      );
    },
    searchRelatedVideos: _.debounce(function() {
      this.lastSearchedWordCount = countWords(
        escapeHTML(this.editor.getHTML()),
      );
      if (!this.isManualSearch) {
        this.$store.dispatch('videos/searchRelatedVideos', {
          title: this.title,
          body: this.editor.getHTML(),
          isManualSearch: false,
        });
      }
    }, parseInt(getEnvVar('VUE_APP_VIDEO_SEARCH_DELAY'))),
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/fixes.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/inputs.scss';

.story-box {
  width: 100%;
  height: calc(100% - 88px);

  @include for-size(phone-only) {
    padding: 0 24px;
    height: 100% !important;
    overflow: hidden;
  }

  a {
    color: #000 !important;
  }

  .story-middle {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 72px 0 0 0;
    padding: 0 16px;
    height: calc(100% - 64px);
    overflow: hidden;

    @include for-size(phone-only) {
      padding: 0;
      height: auto !important;
    }

    .protected-body {
      display: flex;
      height: 100%;
      justify-content: center;
    }

    .story-top,
    .story-content {
      width: 100%;
      padding: 8px 0;
      color: $color-black-80;
    }

    .story-top {
      display: flex;
      flex-flow: wrap row;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;

      .story-title {
        flex: 1;
        margin: 0 40px 0 0;

        ::v-deep .v-input {
          .v-input__control {
            .v-input__slot {
              padding: 0;
              border-radius: 0;
              font-size: 1.4em;
              font-family: 'globotipo' !important;
              font-weight: 300 !important;
              line-height: 1.2em;
            }
          }
        }
      }

      .story-actions {
        width: auto;
        display: flex;
        flex-flow: wrap row;
        justify-content: flex-end;
        align-items: center;

        .v-btn {
          &.secondary {
            margin: 0 8px 0 0;
          }

          .v-icon {
            will-change: color;
            transition: color 0.6s ease-in-out;
          }

          &.is-active {
            .v-icon {
              color: $color-primary !important;
            }
          }
        }

        .menubar {
          opacity: 1;
          will-change: opacity;
          transition: opacity 0.4s ease-in-out;
          pointer-events: all;

          &.disabled {
            opacity: 0.24;
            pointer-events: none;
          }
        }

        .divisor {
          width: 1px;
          height: 24px;
          background-color: $color-black-08;
          margin: 0 8px;

          &.right {
            margin: 0 16px 0 8px;
          }
        }
      }

      // Mobile
      @media screen and (max-width: 800px) {
        flex-flow: wrap column-reverse;

        .story-title,
        .story-actions {
          width: 100%;
        }

        .story-title {
          margin: 16px auto 0 0;
        }

        .story-actions {
          margin: 0 0 0 auto;

          .divisor {
            display: none;
          }

          .menubar {
            margin: 0 auto 0 -8px;
          }
        }
      }
    }

    .story-content {
      position: relative;
      padding: 0;
      margin: -2px 0 0 0;
      flex-grow: 1;
      min-height: 0;
      font-size: 0.8em;
      line-height: 1.4em;
      overflow-y: auto;
      border-top: solid 1px $color-black-08;
      border-bottom: solid 1px $color-black-08;

      @include for-size(phone-only) {
        margin: 0;
        overflow: hidden;
        border-bottom: none !important;
      }

      ::v-deep hlt {
        background-color: $color-highlight;
        font-family: 'globotipo' !important;
        font-weight: 600 !important;
      }

      ::v-deep .ProseMirror {
        padding: 24px 8px 24px 0;
        font-size: 1.2em;
        font-family: 'globotipo' !important;
        font-weight: 400 !important;
      }

      ::v-deep .ProseMirror,
      ::v-deep .ProseMirror-focused {
        outline: none !important;
      }
    }

    // Metadados
    .story-fields {
      width: 100%;
      padding: 16px;
      background-color: $color-black-04;
      border-top: solid 1px $color-black-08;

      // Controle de inputs
      ::v-deep .v-input {
        .v-input__control {
          .v-input__slot {
            label {
              font-size: 0.88em !important;
              margin-top: 1px;
            }
          }
        }
        &.v-input--checkbox,
        .v-input--is-label-active {
          label {
            left: 0px !important;
          }
          margin-top: 0;
          height: 56px;
          border-radius: 4px !important;
          background-color: $color-white;
          display: flex;
          align-items: center;
          .v-input--selection-controls__input {
            margin-left: 12px;
          }
        }

        &.v-input--is-focused {
          .v-input__control {
            .v-input__slot {
              .v-text-field__slot {
                label {
                  display: none;
                }
              }
            }
          }
        }
      }

      .meta-chips {
        background-color: $color-black-04;
        padding: 4px 8px;
        border-radius: 4px;

        .meta-chip {
          background-color: transparent;
          padding: 0;
          font-family: 'globotipo' !important;
          font-weight: 500 !important;
          font-size: 0.8em;
          color: $color-black-56;
          text-transform: lowercase;
        }
      }
    }
  }

  .story-footer {
    position: relative;
    display: flex;
    flex-flow: wrap column;
    justify-content: flex-start;
    width: 100%;
    height: 64px;
    padding: 0 16px;
    box-sizing: border-box;
    border-radius: 0 0 4px 4px;

    @include for-size(phone-only) {
      display: none;
    }

    &.mobile {
      display: none;

      @include for-size(phone-only) {
        position: fixed;
        z-index: 0;
        display: flex;
        width: 100%;
        padding: 0;
        background-color: $color-white !important;
        border-top: solid 1px $color-black-08;
      }
    }

    .slot {
      &.right {
        flex: none;
        width: 16px;
      }
    }
    @media screen and (max-width: 800px) {
      flex-flow: inherit;

      .slot {
        &.left {
          flex: 1;
          flex-wrap: nowrap;
          overflow-x: auto;

          .slot-item {
            flex: 0 0 auto;
          }
        }
      }
    }
  }
}

.story-header,
.story-box {
  box-shadow: 0 2px 8px 0 rgba($color-black, 0.08);
  background-color: $color-white;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  animation: fadeIn 0.6s ease-in-out;

  .slot {
    min-height: 100%;
    display: flex;
    align-items: center;

    .slot-item {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      margin: 0 16px 0 0;
      padding: 0;

      .v-icon {
        font-size: 1.2em;
        margin: -2px 4px 0 0;
        color: $color-black-16;
      }

      .v-chip {
        display: flex;
        flex-wrap: wrap;
        font-family: 'globotipo' !important;
        font-weight: 500 !important;
        font-size: 0.8em;
        color: $color-black-40;
        text-transform: uppercase;
        border: none;
        margin: 0 !important;
        padding: 0 !important;

        &.path {
          &::after {
            content: '/';
            color: $color-black-24;
            margin: 0 2px;
          }
        }

        &.name {
          text-transform: lowercase;
        }
      }

      .v-btn {
        &.link {
          .v-icon {
            color: $color-black-80;
          }
        }
      }
    }

    &.left {
      flex: 1;
      justify-content: flex-start;
    }

    &.right {
      flex: 2;
      justify-content: flex-end;

      .slot-item {
        margin: 0 0 0 16px;
      }
    }
  }
}

.error-snack-custom {
  ::v-deep .v-snack__content {
    flex-direction: column;
    align-items: flex-start;
    span {
      margin: 5px 0 0 0;
    }
    .v-btn {
      align-self: flex-end;
    }
  }
}
</style>
